import PageHero from "@/components/feature/PageHero";
import Reveal from "@/components/base/Reveal";
import ContactForm from "./components/ContactForm";
import { telHref, useContent } from "@/content/ContentProvider";

export default function Consult() {
  const site = useContent("site.settings");
  const infoItems = [
    { icon: "ri-phone-line", label: "전화", value: site.phone },
    { icon: "ri-time-line", label: "운영시간", value: site.hours },
    { icon: "ri-map-pin-line", label: "위치", value: site.address },
  ];

  return (
    <>
      <PageHero page="consult" />

      <section className="bg-background-50 py-16 md:py-24">
        <div className="mx-auto max-w-content px-5 md:px-8">
          <div className="grid gap-10 lg:grid-cols-12 lg:gap-12">
            <Reveal className="lg:col-span-7">
              <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
                상담 신청
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                아래 내용을 작성해 주시면, 담당 선생님이 확인 후 연락드립니다.
              </p>
              <div className="mt-6">
                <ContactForm />
              </div>
            </Reveal>

            <Reveal delay={100} className="lg:col-span-5">
              <div className="space-y-4">
                <div className="rounded-2xl border border-background-200 bg-background-100/70 p-6">
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    학원 정보
                  </h3>
                  <ul className="mt-5 space-y-5">
                    {infoItems.map((item) => (
                      <li key={item.label} className="flex items-start gap-3">
                        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                          <i className={`${item.icon} text-lg`} />
                        </span>
                        <div>
                          <p className="font-label text-[11px] tracking-wide text-foreground-600">
                            {item.label}
                          </p>
                          <p className="mt-0.5 text-sm font-bold text-foreground-950">
                            {item.value}
                          </p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="rounded-2xl bg-foreground-950 p-6 text-white">
                  <h3 className="font-heading text-base font-bold">상담 안내</h3>
                  <p className="mt-3 text-sm leading-relaxed text-white/70">
                    상담 시 학생의 최근 시험 성적표나 학습지가 있으시면 함께
                    준비해 주세요. 보다 정확한 진단과 상담이 가능합니다.
                  </p>
                  <a
                    href={telHref(site.phone)}
                    className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-3 text-sm font-bold text-foreground-950 transition-colors hover:bg-primary-400 cursor-pointer"
                  >
                    <i className="ri-phone-line" />
                    전화로 바로 상담
                  </a>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}